import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import "./assets/style.css"
import axios from 'axios'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { useAuthClientStore } from './store/useAuthClientStore'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
axios.defaults.baseURL = process.env.VUE_APP_API_URL

const app = createApp(App);
app.use(pinia);
app.use(router);
app.use(store)

// Attache le token client aux requêtes ; déconnecte si le token a expiré
const authClientStore = useAuthClientStore()
axios.interceptors.request.use((config) => {
  const token = authClientStore.token
  if (token) {
    try {
      const { exp } = JSON.parse(atob(token.split('.')[1]))
      if (Date.now() >= exp * 1000) {
        authClientStore.logout()
        router.push({ name: 'connexion' })
        return Promise.reject(new Error('Session expirée'))
      }
    } catch (e) { /* token illisible : on laisse passer */ }
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

app.mount('#app');